<script lang="ts">
	import type { CardItem } from "./ArticleCardProps.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import translations from "./ArticleCard.translations.json";
	import logo from "../../../core/assets/logo-blue.svg";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import DynamicPicture from "./Picture/DynamicPicture.svelte";
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import Link from "./Link.svelte";
	import { getTranslate } from "../utils/getTranslate.js";

	export let card: CardItem;

	const translate = getTranslate(translations);
</script>

<div
	class="border-lttertiary group flex size-full flex-col overflow-hidden border-b border-r p-4 duration-300 ease-in-out md:p-6 lg:p-8"
>
	<div class="flex flex-1 flex-col">
		<a href={card.href} class="relative block" tabindex="-1" aria-hidden="true">
			{#if card.primaryImage}
				<DynamicPicture
					class="w-full overflow-hidden object-cover object-center"
					imgClass="w-full h-auto object-cover object-center"
					alt={card.title}
					image={card.primaryImage}
					width={0}
					height={0}
					bucket="storage"
					sourcesets={{
						"<md": [550, 0],
						">md": [684, 0],
						">lg": [440, 0],
						">xl": [306, 0],
					}}
				/>
			{:else}
				<div class="flex h-72 w-full items-center justify-center bg-white">
					<StaticPicture alt="" image={logo} width={250} height={38} class="m-auto w-40" imgClass="h-auto w-full" />
				</div>
			{/if}
			{#if card.hasBadge}
				<span
					class="text-ltprimary-300 bg-lttertiary-100 font-bahnschrift text-2xs/none absolute left-px top-px inline-flex h-6 items-center px-2 font-normal uppercase tracking-wider"
				>
					{translate("caseStudyLabel")}
				</span>
			{/if}
		</a>
		<article class="bg-ltwhiteout relative z-[1] flex flex-1 flex-col gap-4 pt-5 md:gap-5 md:pt-6 lg:pt-8">
			<p
				class="text-ltprimary font-bahnschrift md:!text-2md lg:!text-2lg !text-md !m-0 line-clamp-2 font-light uppercase leading-[1.1] tracking-normal"
			>
				<a href={card.href}>{nbspify(card.title)}</a>
			</p>
			<div class="text-ltsecondary font-lexend line-clamp-3 text-xs/[1.6] font-normal tracking-normal md:text-base">
				{nbspify(card.perex)}
			</div>
			<Link
				aria-label={translate("readMoreAria", {}, true)}
				class="font-roboto mt-auto self-start pt-3 text-xs/none !font-medium uppercase tracking-wider md:pt-6 md:text-base"
				iconGap="mr-0"
				variant="underline"
				icon={arrowRight}
				href={card.href}>{translate("readMore")}...</Link
			>
		</article>
	</div>
</div>
